import { render } from "./CurrencyCompare.vue?vue&type=template&id=213ef6d2&ts=true"
import script from "./CurrencyCompare.vue?vue&type=script&lang=ts"
export * from "./CurrencyCompare.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__